import type { ConnectedDataset } from "../../../pages/Connectors/api";

export interface ConnectionFilePreviewConfig {
  columns: string[];
  rows: Record<string, unknown>[];
  totalRowCount: number;
  onReupload: () => void;
  onDownload: () => void;
}

type ConnectedDatasetSectionBaseProps = {
  expanded: boolean;
  onToggle: () => void;
  isActionDisabled?: boolean;
  className?: string;
};

export type ConnectedDatasetSectionDatasetProps =
  ConnectedDatasetSectionBaseProps & {
    filePreview?: undefined;
    connectionId?: string;
    datasets: ConnectedDataset[];
    onEditDataset: () => void;
    showEditDataset?: boolean;
    onScheduleRefresh: (table: string, assetId: string) => void;
    onDatasetPaginationChange?: () => void;
  };

export type ConnectedDatasetSectionFilePreviewProps =
  ConnectedDatasetSectionBaseProps & {
    filePreview: ConnectionFilePreviewConfig;
    connectionId?: string;
    datasets?: ConnectedDataset[];
    onEditDataset?: () => void;
    showEditDataset?: boolean;
    onScheduleRefresh?: (table: string, assetId: string) => void;
    onDatasetPaginationChange?: () => void;
  };

export type ConnectedDatasetSectionProps =
  | ConnectedDatasetSectionDatasetProps
  | ConnectedDatasetSectionFilePreviewProps;

export function isConnectedDatasetSectionFilePreviewProps(
  props: ConnectedDatasetSectionProps,
): props is ConnectedDatasetSectionFilePreviewProps {
  return props.filePreview !== undefined;
}
